<template>
  <div>
    <van-nav-bar :title="barTitle" :left-text="leftText" @click-left="onClickLeft" />
    <van-form ref="form" @submit="save">
      <van-tabs v-model="active">
        <van-tab title="基础信息">
          <base-input v-model="form.consult_date" :required="true" label="日期" disabled />
          <base-datetime v-model="form.expiry_date" :required="true" label="截止时间" />
          <base-input v-model="form.linkman" :required="true" label="联系人" />
          <base-input v-model="form.phone" :required="true" label="联系方式" />
          <base-textarea v-model="form.info" :maxlength="500" :required="true" label="内容" />
          <base-textarea v-model="form.comment" :maxlength="500" :required="true" label="不能交付原因" />
          <base-select v-model="form.status" :options="CONST.CONSULT_SHARED_STATUS" :required="true" label="状态" />
          <base-search-select v-model="form.client_name" label="签约客户" @change="onClientSelectChange" />
          <base-select v-model="form.product_id" :options="dictProductList" label="服务" />
          <base-cascader v-model="form.dept_id" :options="deptList" label="承接分公司" />
          <base-search-select v-model="form.sell_emp_name" :url="'/employee/dict'" label="承接销售人员" @change="onEmpSelectChange" />
        </van-tab>
        <van-tab title="跟进信息">
          <van-row>
            <van-col offset="18" span="6" style="padding-top: 5px">
              <base-button type="primary" @click="addFollow">新增跟进记录</base-button>
            </van-col>
          </van-row>
          <van-row class="list-title">
            <van-col span="6">跟进日期</van-col>
            <van-col span="4">跟进人</van-col>
            <van-col span="10">备注</van-col>
            <van-col span="4">操作</van-col>
          </van-row>
          <van-cell v-for="detail in form.details" :key="detail.id" class="list-tip" >
            <van-col span="6" style="text-align: center">
              <!-- <base-input :type="'date'" v-model="detail.follow_date" disabled /> -->
              {{ detail.follow_date }}
            </van-col>
            <van-col span="4" style="text-align: center">
              {{ detail.emp_name }}
            </van-col>
            <van-col span="10" style="text-align: center">
              <base-textarea v-model="detail.comment" />
            </van-col>
            <van-col span="4" style="text-align: center">
              <van-icon name="cross" style="padding-top: 5px;" @click="delFollow(detail)" />
            </van-col>
          </van-cell>
        </van-tab>
      </van-tabs>
      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
    <init :init-states="initStates" @after-init="init" />
  </div>
</template>

<script>
import { Dialog } from 'vant'
import { Toast } from 'vant'
import { mapGetters } from 'vuex'
import { getProductList } from '@/api/product'
import { getDeptList } from '@/api/dept'
import { addShared, modifyShared, addSharedDetail,
  modifySharedDetail, deleteSharedDetail } from '@/api/consultShared'
import Init from '@/components/base/init'
export default {
  name: 'ConsultSharedEdit',
  components: { Init },
  data() {
    return {
      barTitle: '新增资源共享',
      leftText: '',
      active: 0,
      data: [],
      currDate: '', // 当前日期
      dictProductList: [], // 全产品
      detailsMap: [],
      deptList: [],
      last_status: null, //修改前状态

      queryCondition: {
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS
      },
      form: {
        consult_date: null,
        expiry_date: null,
        linkman: '',
        phone: '',
        status: null,
        info: '',
        comment: '',
        client_id: null,
        product_id: null,
        dept_id: null,
        sell_emp_id: null,
        sell_emp_name: '',
        details: []
      },
      initStates: [{
        key: 'app/initCurrentDate'
      }]
    }
  },
  computed: {
    ...mapGetters(['currentDate', 'selectedShared'])
  },
  mounted() {
    const now = new Date()
    this.currDate = this.Utils.df(now);
    this.query()
    this.init()
  },
  methods: {
    init() {
      this.resetForm()
      setTimeout(() => {
        this.form.consult_curr_date = this.$store.state.app.currentDate;
      }, 500);

      if (this.selectedShared) {
        this.last_status = this.selectedShared.status;
        console.log(this.last_status)
        this.form.consult_curr_date = this.currentDate;
        this.barTitle = '修改资源共享'
        this.leftText = '返回'
        if (!this.selectedShared.details) {
          this.selectedShared.details = []
        }
        const data = this._.cloneDeep(this.selectedShared)
        data.details = data.details ? data.details : []
        data.details.forEach(item => {
          this.detailsMap[item.id] = item.comment
        })
        data.consult_date = data.consult_date.slice(0, 10)
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
          duration: 0,
          overlay: true
        })
        setTimeout(() => {
          this.form = data
          Toast.clear()
        }, 2000)
      }
    },
    onClientSelectChange(name, value) {
      if (value) {
        this.form.client_id = value.id
      }
    },
    onEmpSelectChange(name, value) {
      if (value) {
        this.form.sell_emp_id = value.id
      }
    },
    resetForm() {
      this.Utils.resetValue(this.form)
      this.form.consult_date = this.currDate
      this.form.status = 1
    },
    query() {
      this.queryProductList()
      this.queryDeptList()
    },
    queryProductList() {
      getProductList(this.queryCondition).then(resp => {
        this.dictProductList = resp.rows || []
      })
    },
    queryDeptList() {
      getDeptList(this.queryCondition).then(resp => {
        this.deptList = resp.rows || []
      })
    },
    onClickLeft() {
      this.$router.push('/consult-shared/manage')
    },
    addFollow() {
      this.form.details.push({
        follow_date: this.Utils.df(Date.now()),
        create_name: '',
        comment: ''
      })
    },
    saveFollow(type, postData) {
      if (type === 'modify') {
        modifySharedDetail(postData).then(resp => {
          if (resp.success) {
            // this.success(resp.msg)
          }
        })
      } else if (type === 'add') {
        addSharedDetail(postData).then(resp => {
          if (resp.success) {
            // this.success(resp.msg)
          }
        })
      }
    },
    delFollow(follow) {
      if (follow.id) {
        console.log(follow)
        if (follow.create_id != this.$store.state.user.userInfo.emp_id) {
          this.toast('跟进记录只允许创建人删除！')
          return
        }
        Dialog.confirm({
          title: '提示',
          message: '确定删除跟进记录吗？'
        }).then(() => {
          deleteSharedDetail({
            id: parseInt(follow.id)
          }).then(resp => {
            if (resp.success) {
              const index = this.form.details.indexOf(follow)
              if (index !== -1) {
                this.form.details.splice(index, 1)
              }
              this.success(resp.msg)
            }
          })
        })
      } else {
        const index = this.form.details.indexOf(follow)
        if (index !== -1) {
          this.form.details.splice(index, 1)
        }
      }
    },
    save() {
      if (this.form.client_name && !this.form.client_id) {
        this.toast('输入关键字后请在列表中选择签约客户')
        return
      }
      if (this.form.sell_emp_name && !this.form.sell_emp_id) {
        this.toast('输入关键字后请在列表中选择指定销售人员')
        return
      }
      if (this.form.status == 3 && !this.form.dept_id) {
        this.toast('请填写承接分公司和承接人员！')
        return
      }
      if (this.form.status == 3 && !this.form.sell_emp_id) {
        this.toast('请填写承接分公司和承接人员！')
        return
      }
      if (this.form.id) {
        if (this.last_status == 3 || this.last_status == 4) {
          this.toast('已承接或已关闭的资源共享禁止修改！')
          return
        }
        if (this.form.status == 4) {
          if (this.form.create_id != this.$store.state.user.userInfo.emp_id) {
            this.toast('资源共享只允许创建人关闭！')
            return
          }
        }
        for (let i = 0; i < this.form.details.length; i++) {
          if (this.form.details[i].id > 0) {
            // 跟进记录有修改时，更新该条记录
            const key = this.form.details[i].id
            const beforeComment = this.detailsMap[key]
            const afterComment = this.form.details[i].comment
            const type = 'modify'
            const postData = {
              id: this.form.details[i].id,
              comment: afterComment
            }
            if (beforeComment !== afterComment) {
              if (this.form.details[i].create_id != this.$store.state.user.userInfo.emp_id) {
                this.toast('跟进记录只允许创建人修改！')
                return
              }
              this.saveFollow(type, postData)
            }
          } else if (!this.form.details[i].id) {
            // 新增跟进记录
            const type = 'add'
            const postData = {
              main_id: this.form.id,
              follow_date: this.form.details[i].follow_date,
              comment: this.form.details[i].comment
            }
            this.saveFollow(type, postData)
          }
        }
        this.saveModifyShared()
      } else {
        addShared(this.form).then(resp => {
          if (resp.success) {
            this.success(resp.msg)
            this.$router.push('/consult-shared/manage')
          }
        })
      }
    },
    saveModifyShared() {
      modifyShared(this.form).then(resp => {
        if (resp.success) {
          this.success(resp.msg);
          this.$router.push('/consult-shared/manage');
        }
      });
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/consult-shared/shared-edit.vue